export default __webpack_public_path__ + "static/assets/d0b4a333e34ac8d5c856ade089135bfb.png";